// The API normalizes manager time zones to these seven US zones. Unknown zones omit the row.
export const RELATIONSHIP_MANAGER_TIME_ZONE_LABEL_KEYS = {
  'America/New_York': 'relationshipManager.timeZones.eastern',
  'America/Chicago': 'relationshipManager.timeZones.central',
  'America/Denver': 'relationshipManager.timeZones.mountain',
  'America/Phoenix': 'relationshipManager.timeZones.arizona',
  'America/Los_Angeles': 'relationshipManager.timeZones.pacific',
  'America/Anchorage': 'relationshipManager.timeZones.alaska',
  'Pacific/Honolulu': 'relationshipManager.timeZones.hawaii',
} as const;

export const PHONE_NUMBER_LENGTH = 10;
